import { useParams } from 'react-router-dom'

import TasksList from './components/TasksList'
import useToken from 'token/shared/hooks/useToken'

const Container = () => {
  const { workflowUuid } = useParams()

  const { token, metadata, isFetching } = useToken({ tokenUuid: workflowUuid })

  if (isFetching) {
    return null
  }

  return (
    <div>
      {token?.uuid}
      <br />
      <br />
      {token && <TasksList token={token} metadata={metadata} />}
    </div>
  )
}

export default Container
